import React from 'react';
import { useAuth } from '../context/AuthContext';

export function LoginPage() {
  const { signIn } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <div className="bg-white rounded-xl shadow-lg p-8 max-w-sm w-full text-center">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-slate-900">MockCRM</h1>
          <p className="text-sm text-slate-500 mt-1">CRM Mock System</p>
        </div>
        <button
          onClick={signIn}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-[#0078d4] text-white rounded-md hover:bg-[#106ebe] transition-colors text-sm font-medium"
        >
          <svg width="20" height="20" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
            <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
            <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
            <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
          </svg>
          Login through Microsoft
        </button>
      </div>
    </div>
  );
}
